import { Labels } from '../labels';

export default function Footer() {
  return (
    <div className='footer'>
      {Labels.Footer.getValue()}
    </div>
  );
}
